import React, { Component } from "react";
import { withScope, captureException, showReportDialog } from "@sentry/browser";

/**
 * Root error boundary.
 */
class AppBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { eventId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const chunkFailedMessage =
      /Loading chunk \d+ failed|Failed to fetch dynamically imported module/;
    if (error?.message && chunkFailedMessage.test(error.message)) {
      // The user probably had a tab open before a deploy, and the code-splitting encountered an outdated chunk
      // filename hash. So just reload the page, and it should be fine. Solution #3 from:
      // https://mitchgavan.com/code-splitting-react-safely/

      window.location.reload();
      return;
    }

    withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    if (this.state.hasError) {
      //render fallback UI
      return this.props.fallbackRender ? (
        this.props.fallbackRender(this.state.error)
      ) : (
        <button
          onClick={() => showReportDialog({ eventId: this.state.eventId })}
        >
          Report feedback
        </button>
      );
    }

    //when there's not an error, render children untouched
    return this.props.children;
  }
}

export default AppBoundary;
